import { useAuth } from "@/context/AuthContext";
import { AlertTriangle, PhoneCall, Clock } from "lucide-react";

// Shows a persistent banner when the motel is read-only (disabled / unpaid) or
// inside the non-payment grace window (daily countdown). View-only accounts can
// still see all data; writes are blocked server-side.
export function AccessBanner() {
  const { motel } = useAuth();
  const access = motel?.access;
  const contact = motel?.contact || "+64 027 452 4519";
  if (!access) return null;

  if (access.reason === "grace") {
    return (
      <div
        data-testid="access-banner-grace"
        className="flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-center text-sm font-semibold text-white"
      >
        <Clock className="h-4 w-4 shrink-0" />
        Payment overdue — this account will be disabled in {access.days_left} day{access.days_left === 1 ? "" : "s"}. Please settle your invoice to avoid interruption.
      </div>
    );
  }

  if (access.readonly) {
    const disabled = access.reason === "disabled";
    return (
      <div
        data-testid="access-banner-readonly"
        className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 bg-destructive px-4 py-2 text-center text-sm font-semibold text-white"
      >
        <AlertTriangle className="h-4 w-4 shrink-0" />
        {disabled
          ? "This account is disabled — view only."
          : "This account is locked for non-payment — view only."}
        <span className="inline-flex items-center gap-1">
          <PhoneCall className="h-4 w-4" /> Contact KlenaPro on {contact} to reactivate.
        </span>
      </div>
    );
  }

  return null;
}
